import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import theme from './theme/theme';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import Auth from './pages/Auth';
// import Dashboard from './pages/Dashboard';
import SimpleDashboard from './pages/SimpleDashboard';
import Profile from './pages/Profile';
import Subscriptions from './pages/Subscriptions';
import UserManagement from './pages/UserManagement';
import AddSubscription from './pages/AddSubscription';
import AddUser from './pages/AddUser';
import Events from './pages/Events';
import EventManagement from './pages/EventManagement';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import SystemConfiguration from './pages/SystemConfiguration';
import UserActivityHistory from './pages/UserActivityHistory';
import PaymentProcessing from './pages/PaymentProcessing';
import Plans from './pages/Plans';
import Blog from './pages/Blog';
import BlogManagement from './pages/BlogManagement';
import DynamicFieldManagement from './pages/DynamicFieldManagement';
import IconManagement from './pages/IconManagement';
import EnhancedDashboard from 'pages/EnhancedDashboard';
import KYCVerification from './pages/KYCVerification';
import OffersManagement from 'pages/OfferManagement';
import OpportunityManagement from 'pages/OpportunityManagement';
import SubscriptionManagement from './pages/SubscriptionManagement';
import LBKWalletManagement from './pages/LBKWalletManagement';

// Components
// import Layout from './components/Layout';
import SimpleLayout from './components/SimpleLayout';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null; // or a loading spinner
  }

  return isAuthenticated ? children : <Navigate to="/auth" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <ToastContainer 
            position="top-right" 
            autoClose={3000}
            theme="colored"
            style={{ marginTop: '64px' }}
          />
          <Routes>
            <Route path="/auth" element={<Auth />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <SimpleLayout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<EnhancedDashboard />} />
              <Route path="profile" element={<Profile />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="subscriptions/new" element={<AddSubscription />} />
              <Route path="plans" element={<Plans />} />
              <Route path="events" element={<Events />} />
              <Route path="blog" element={<Blog />} />
              <Route path="activity-history" element={<UserActivityHistory />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="/kyc-verification" element={<KYCVerification />} />
              <Route path="add-user" element={<AddUser />} />
              <Route path="blog-management" element={<BlogManagement />} />
              <Route path="event-management" element={<EventManagement />} />
              <Route path="offer-management" element={<OffersManagement />} />
              <Route path="opportunity-management" element={<OpportunityManagement />} />
              <Route path="subscription-management" element={<SubscriptionManagement />} />
              <Route path="lbk-wallet" element={<LBKWalletManagement />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="payments" element={<PaymentProcessing />} />
              <Route path="system-configuration" element={<SystemConfiguration />} />
              <Route path="dynamic-fields" element={<DynamicFieldManagement />} />
              <Route path="icon-management" element={<IconManagement />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 